import telLinker from "@root/services/telLinker";
import cygnusSpriteHtml from "@root/services/icons/cygnusSpriteHtml";

function mapIcon(type) {
  switch (type) {
    case 'MOBILE':
      return cygnusSpriteHtml('mobile', { variant: 'solid', title: 'Mobile' });
    case 'WORK':
      return cygnusSpriteHtml('building', { variant: 'solid', title: 'Work' });
    case 'HOME':
      return cygnusSpriteHtml('home', { variant: 'solid', title: 'Home' });
    case 'FAX':
      return cygnusSpriteHtml('fax', { variant: 'solid', title: 'Fax' });
  }
}

export default function (cell, formatterParams) {
  let value = cell.getValue() || '';

  if (typeof value === 'string') {
    value = JSON.parse(value);
  }

  //if new value is an array we need to convert it to an object
  if (Array.isArray(value)) {
    value = Object.assign({}, ...value);
  }


  if (!value) {
    return '';
  }


  const data = Object.entries(value).map(([type, phone]) => {
    const { href, label } = telLinker(phone.replace(/[^0-9+]/, ''));

    const icon = mapIcon(type)

    return `${icon} <a href="${href}">${label}</a>`;
  }).join('<br/>');

  const div = document.createElement('div');
  div.innerHTML = data;

  return div;
}
